import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import type { ExecWorkerInterface } from "#/features/codeRunner/lib/workers/codeExec.worker";
import { requestBenchmarkWithProgress, requestWorkerAction } from "#/features/codeRunner/lib/workers/codeExecWorkerInterface";
import type { ExecutionResult } from "./useCodeExecution";
import { useJSWorker } from "./useJSWorker";
type RunParams = ExecWorkerInterface["run"]["request"];
type BenchmarkParams = ExecWorkerInterface["benchmark"]["request"];
export const useJSCodeRunner = () => {
  const $ = _c(8);
  const {
    worker
  } = useJSWorker();
  let t0;
  if ($[0] !== worker) {
    t0 = async (codeInput, params, onProgress) => {
      if (!worker) {
        throw new Error("Worker not initialized");
      }
      const request = {
        type: "benchmark" as const,
        code: codeInput,
        input: params.input,
        count: params.count
      };
      const result = onProgress ? await requestBenchmarkWithProgress(worker, request, onProgress) : await requestWorkerAction(worker, "benchmark", request);
      return {
        output: result.output || "",
        callstack: [],
        runtime: result.runtime,
        startTimestamp: result.workStartTime,
        error: result.error ? {
          name: result.error.name,
          message: result.error.message,
          stack: result.error.stack
        } : undefined,
        benchmarkResults: result
      };
    };
    $[0] = worker;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const runJSBenchmark = t0;
  let t1;
  if ($[2] !== worker) {
    t1 = async (codeInput_0, params_0) => {
      if (!worker) {
        throw new Error("Worker not initialized");
      }
      const result_0 = await requestWorkerAction(worker, "run", {
        type: "run",
        code: codeInput_0,
        caseArgs: params_0.caseArgs,
        arrayStore: params_0.arrayStore,
        treeStore: params_0.treeStore
      });
      return {
        output: result_0.output || "",
        callstack: result_0.callstack || [],
        runtime: result_0.runtime,
        startTimestamp: result_0.workStartTime,
        error: result_0.error ? {
          name: result_0.error.name,
          message: result_0.error.message,
          stack: result_0.error.stack
        } : undefined
      };
    };
    $[2] = worker;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const runJSCode = t1;
  let t2;
  if ($[4] !== runJSBenchmark || $[5] !== runJSCode || $[6] !== worker) {
    t2 = {
      worker,
      runJSBenchmark,
      runJSCode
    };
    $[4] = runJSBenchmark;
    $[5] = runJSCode;
    $[6] = worker;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};